import { Placement } from "@floating-ui/core/src/types";
import * as React from "react";
import * as styles from "./PopupArrow.less";

type Props = {
    x: number;
    y: number;
    placement: Placement;
};

export const PopupArrow = React.forwardRef<HTMLDivElement, Props>(({ x, y, placement }, ref) => {
    const staticSide = {
        top: "bottom",
        right: "left",
        bottom: "top",
        left: "right",
    }[placement.split("-")[0]];

    const style: React.CSSProperties = {
        top: y ?? "",
        left: x ?? "",
        right: "",
        bottom: "",
        [staticSide]: -4,
    };

    return <div ref={ref} className={styles.arrow} style={style} />;
});
